
      var _image, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 16,
  height: 16,
  textRendering: "geometricPrecision",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "mobile_b22d5cce6fa04d2e__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABlBMVEVMaXH///+a4ocPAAAAAnRSTlMAtc2YijsAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAASSURBVHjaY2CgGmBkJCQwBAAABAAABZyhzBAAAAAASUVORK5CYII=",
  width: 16,
  height: 16,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABlBMVEVMaXH///+a4ocPAAAAAnRSTlMAtc2YijsAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAASSURBVHjaY2CgGmBkJCQwBAAABAAABZyhzBAAAAAASUVORK5CYII=",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
}))), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAG1BMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACalcoGAAAACXRSTlMAqJ3uBmjJHGmVKAm0AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAP0lEQVR42rWPSQ4AIAgDKYv4/xerEU0IXu1lwlxaiF5RY4BN790EM9KO6eILLhaCsQkOAWT+EaW2DCvTy3MpA3C7ANP1fiE1AAAAAElFTkSuQmCC",
  width: 16,
  height: 16,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAG1BMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACalcoGAAAACXRSTlMAqJ3uBmjJHGmVKAm0AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAP0lEQVR42rWPSQ4AIAgDKYv4/xerEU0IXu1lwlxaiF5RY4BN790EM9KO6eILLhaCsQkOAWT+EaW2DCvTy3MpA3C7ANP1fiE1AAAAAElFTkSuQmCC",
  preserveAspectRatio: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#mobile_b22d5cce6fa04d2e__a)",
  shapeRendering: "crispEdges",
  d: "M0 0h16v16H0z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"16\" height=\"16\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 16 16\"><defs><mask id=\"layer-0\" width=\"16\" height=\"16\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABlBMVEVMaXH///+a4ocPAAAAAnRSTlMAtc2YijsAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAASSURBVHjaY2CgGmBkJCQwBAAABAAABZyhzBAAAAAASUVORK5CYII=\" width=\"16\" height=\"16\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABlBMVEVMaXH///+a4ocPAAAAAnRSTlMAtc2YijsAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAASSURBVHjaY2CgGmBkJCQwBAAABAAABZyhzBAAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask></defs><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAG1BMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACalcoGAAAACXRSTlMAqJ3uBmjJHGmVKAm0AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAP0lEQVR42rWPSQ4AIAgDKYv4/xerEU0IXu1lwlxaiF5RY4BN790EM9KO6eILLhaCsQkOAWT+EaW2DCvTy3MpA3C7ANP1fiE1AAAAAElFTkSuQmCC\" id=\"convert2-underlay\" width=\"16\" height=\"16\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAG1BMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACalcoGAAAACXRSTlMAqJ3uBmjJHGmVKAm0AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAP0lEQVR42rWPSQ4AIAgDKYv4/xerEU0IXu1lwlxaiF5RY4BN790EM9KO6eILLhaCsQkOAWT+EaW2DCvTy3MpA3C7ANP1fiE1AAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\"/><rect width=\"16\" height=\"16\" fill=\"var(--theme-primary, #810ea9)\" mask=\"url(#layer-0)\" shape-rendering=\"crispEdges\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/mobile.b22d5cce6fa04d2e9c7c354c83351092.svg"),
        {
          React: SvgMobile,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      